export default __webpack_public_path__ + "static/media/logo.0458ba98.svg";